<div fxLayout="column" fxLayoutGap="15px">
  <app-file-drag-and-drop
    [multiple]="false"
    [generateOutput]="true"
    (fileSelected)="fileSelected($event)"
    [maxSize]="fileMaxSize"
    acceptMime="*/*"
  ></app-file-drag-and-drop>

  <div fxLayout="row">
    <app-dict
      fxFlex="100"
      label="Typ"
      dictType="invoice_document_type"
      [control]="typeControl"
      [required]="true"
    ></app-dict>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Numer</mat-label>
      <input matInput placeholder="Numer" [formControl]="numberControl" [required]="true">
      <mat-error *ngIf="numberControl.hasError('required')">To pole jest wymagane</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <mat-form-field fxFlex="100">
      <mat-label>Kwota</mat-label>
      <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="netControl">
      <mat-error *ngIf="netControl.hasError('required')">To pole jest wymagane</mat-error>
      <mat-error *ngIf="netControl.hasError('backendError')">{{netControl.getError('backendError')}}</mat-error>
    </mat-form-field>

    <app-datepicker
      fxFlex="50"
      label="Data wystawienia"
      placeholder="2000-01-01 00:00"
      [required]="true"
      [control]="issueDateControl"
    ></app-datepicker>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Powód</mat-label>
      <textarea [formControl]="reasonControl" matInput placeholder="Powód"></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!documentForm.valid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
